import { render } from "./AppSidemenu.vue?vue&type=template&id=87fac428"
import script from "./AppSidemenu.vue?vue&type=script&lang=js"
export * from "./AppSidemenu.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent01/user/2766/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ui/menu/AppSidemenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87fac428"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87fac428', __exports__)) {
    console.log('reload')
    api.reload('87fac428', __exports__)
  }
  
  module.hot.accept("./AppSidemenu.vue?vue&type=template&id=87fac428", () => {
    console.log('re-render')
    api.rerender('87fac428', render)
  })

}


export default __exports__